/**
 * Task name suffixes for vital stats tracking.
 * The full task name is: `${surfacePrefix}/${TASK_SUFFIX}`
 * e.g., 'search-page/first-party-config-ux' or 'quick-find/first-party-config-ux'
 */
export const CONFIG_TASK_SUFFIXES = {
	FIRST_PARTY_CONFIG_UX: 'first-party-config-ux',
	FIRST_PARTY_CONFIG_NETWORK: 'first-party-config-network',
	THIRD_PARTY_CONFIG_UX: 'third-party-config-ux',
	THIRD_PARTY_CONFIG_NETWORK: 'third-party-config-network',
	COMBINED_CONFIG_UX: 'combined-config-ux',
	COMBINED_CONFIG_NETWORK: 'combined-config-network',
} as const;
